import { useEffect, useState } from "react";
import { getAssetBaseUrl } from "../services/AssetConfigService";

export interface IAssetBaseUrl {
  baseUrl?: string;
  loading: boolean;
  error?: Error;
}

/** Shared asset base URL from Firestore `app_config/assets` (cached per page load). */
export const useAssetBaseUrl = (): IAssetBaseUrl => {
  const [state, setState] = useState<IAssetBaseUrl>({ loading: true });

  useEffect(() => {
    let active = true;

    getAssetBaseUrl()
      .then((baseUrl) => {
        if (active) {
          setState({ baseUrl, loading: false });
        }
      })
      .catch((e: Error) => {
        if (active) {
          setState({ loading: false, error: e });
        }
      });

    return () => {
      active = false;
    };
  }, []);

  return state;
};
